module.exports = __webpack_public_path__ + "img/logo.92484596.gif";